var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",class:{ 'embed-mode': _vm.isEmbed },attrs:{"id":"app","data-bp":_vm.bp}},[_c('router-view'),(_vm.isEmbed)?_c('div',{staticClass:"embed-version-badge",attrs:{"title":'Sparkconverse build ' + _vm.buildVersion}},[_vm._v(" v"+_vm._s(_vm.buildVersion)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }